module.exports = __webpack_public_path__ + "assets/pdf/I01-cn-food-security.6003a14a.pdf";